import { render, staticRenderFns } from "./CompanyPublicInfo.vue?vue&type=template&id=b58d4b04"
import script from "./CompanyPublicInfo.vue?vue&type=script&lang=js"
export * from "./CompanyPublicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports